module.exports = {"pt-BR":{"realEstate":{"team":{"index":{"menu":"Menu","attendants":"Atendentes","managers":"Gerentes","team":"Equipe"}}}}}